module.exports = __webpack_public_path__ + "img/y19.eaea6846.jpg";